export default __webpack_public_path__ + "static/media/Markers_Blue Marker - Boat.31567b78.svg";